import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import React, { forwardRef, useRef } from 'react';
import InputField from '../../../../../../components/inputField/InputField';
import Modal from '../../../../../../core/components/Modal';
import InputTextLengthCounter from '../../../../../../core/components/inputs/inputTextLengthCounter/InputTextLengthCounter';
import InputTypes from '../../../../../../core/enums/InputTypes';
import BaseForm from '../../../../../../core/page/components/baseForm/BaseForm';
import { dateToString } from '../../../../../../core/utils/DateMixins';
import { assignRefs } from '../../../../../../core/utils/Global';
import metaService from '../../../../../../service/MetaService';
import { useUsuarioLogado } from '../../../../Utils';
import styles from './ModalCancelarMeta.module.scss';

const modalCancelarInputs = [
    {
        name: 'descMotivoCancelamento',
        label: 'Justificativa de Cancelamento',
        type: InputTypes.STRING,
        form: { use: true, validate: { required: true, max: 300 } },
    },
    {
        name: 'usuario',
        label: 'Usuário',
        type: InputTypes.STRING,
        form: { use: true },
    },
    {
        name: 'dataCancelamento',
        label: 'Data de Cancelamento',
        type: InputTypes.STRING,
        form: { use: true },
    },
];

function ModalCancelarMeta({ onSave, ...props }, ref) {
    const modalRef = useRef(null);
    const formRef = useRef(null);
    const justificativaRef = useRef(null);
    const user = useUsuarioLogado();

    const Inputs = ({ formik, formController }) => (
        <form onSubmit={formik.handleSubmit} className={`p-grid p-fluid p-col-12 ${styles.form}`}>
            <InputField
                id="descMotivoCancelamento"
                formController={formController}
                formik={formik}
                cols="12"
            >
                <InputTextLengthCounter maxLen={300} ref={justificativaRef} showInDisable>
                    <InputTextarea
                        value={formik.values.descMotivoCancelamento ?? ''}
                        onChange={formik.handleChange}
                        rows={6}
                        disabled={formik.values.situacao?.codgSituacaoMeta === 'CANCELADA'}
                    />
                </InputTextLengthCounter>
            </InputField>
            <InputField id="usuario" formController={formController} formik={formik} cols="12 4">
                <InputText value={formik.values.usuario} onChange={formik.handleChange} disabled />
            </InputField>
            <InputField
                id="dataCancelamento"
                formController={formController}
                formik={formik}
                cols="12 4"
            >
                <InputText
                    value={formik.values.dataCancelamento}
                    onChange={formik.handleChange}
                    disabled
                />
            </InputField>
            <div className={`buttonsRight ${styles.containerButtons}`}>
                <Button
                    label="Cancelar"
                    className="p-button-danger"
                    type="button"
                    icon="pi pi-times"
                    onClick={() => modalRef.current.hide()}
                />
                <Button
                    label="Salvar"
                    className="p-button-info"
                    type="submit"
                    icon="pi pi-check"
                    onClick={() => formController.addCountClick()}
                />
            </div>
        </form>
    );

    const ModalBody = ({ modalData }) => {
        const { id, descMotivoCancelamento = '', situacao } = modalData;

        return (
            <>
                <BaseForm
                    ref={formRef}
                    onSubmit={(data) => metaService.cancelarMeta(data.registro)}
                    redirectOnSave={false}
                    actionOnSave={({ success }) => {
                        if (success && onSave) {
                            onSave();
                        }
                    }}
                    buscarOnLoad={false}
                    initialValues={modalCancelarInputs}
                    prepareInitialValues={async (data) => {
                        setTimeout(() => justificativaRef.current.focus(), 500);
                        return {
                            ...data,
                            usuario: user?.nomeApresentacao,
                            dataCancelamento: dateToString(new Date()),
                            descMotivoCancelamento,
                            situacao,
                            id,
                        };
                    }}
                >
                    <Inputs />
                </BaseForm>
            </>
        );
    };

    return (
        <Modal
            header={
                <>
                    <i className={`pi pi-ban ${styles.iconHeader}`} />
                    Cancelar Meta
                </>
            }
            style={{ maxWidth: '90vw' }}
            ref={assignRefs(ref, modalRef)}
            {...props}
        >
            <ModalBody />
        </Modal>
    );
}

export default forwardRef(ModalCancelarMeta);
